<template>
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h1 class="h4 mb-0">Downloads</h1>
    </div>
  </div>
  <div class="page-section page-section-last">
    <div class="row">
      <a href="../../resources/pdfs/code-template.pdf" target="_blank" class="quick-link col-md-6 mb-4">
        <div class="icon-column">
          <div class="icon">
            <i class="bi bi-printer"></i>
          </div>
        </div>
        <div class="text">
          <div><strong>Order Code Template</strong></div>
          <div class="text-description">Download our printable order code template </div>
        </div>
        <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
      </a>
      <router-link v-if="preferences.showReturnLabels" :to="{ name: 'ReturnLabel'}" class="quick-link col-md-6 mb-4">
        <div class="icon-column">
          <div class="icon">
            <i class="bi bi-printer"></i>
          </div>
        </div>
        <div class="text">
          <div><strong>Freepost labels</strong></div>
          <div class="text-description">Create a freepost label to send your orders to us</div>
        </div>
        <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
      </router-link>
      <div @click="openTurnaroundTimesPdf" class="quick-link col-md-6 mb-4">
        <div class="icon-column">
          <div class="icon">
            <i class="bi bi-printer"></i>
          </div>
        </div>
        <div class="text">
          <div><strong>Turnaround Times</strong></div>
          <div class="text-description">Download our product turnaround times </div>
        </div>
        <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
      </div>
      <div v-if="canSeePriceList" @click="openPriceListPdf" class="quick-link col-md-6 mb-4">
        <div class="icon-column"><div class="icon"><div class="bi bi-printer"></div></div></div>
        <div class="text">
          <div><strong>Price List</strong></div>
          <div class="text-description">Download our price list</div>
        </div>
        <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
      </div>
    </div>
  </div>
</template>

<script>
    import api from "@/services/api";
    import base64 from "@/services/base64";

    export default {
        data() {
            return {
                preferences: {
                    showReturnLabels: false,
                },
            }
        },
        methods: {
            openTurnaroundTimesPdf: function() {
                var pdfWindow = window.open();
                pdfWindow.document.title = "Loading...";

                api
                .get('/api/v1/turnaround-times/' + this.$store.state.currentPracticeId)
                .then((response) => {
                    var blob = base64.toBlob(response.data, 'application/pdf');
                    pdfWindow.location = URL.createObjectURL(blob);
                })
                .catch((error) => {
                    pdfWindow.close();
                    console.log('Catch turnaround times pdf error', error);
                    alert('There was an error downloading the turnaround times, please try again later.');
                });
            },
            openPriceListPdf: function () {
              var pdfWindow = window.open();
              pdfWindow.document.title = "Loading...";

              api
                .get('/api/v1/priceList', {
                  params: { practice_id: this.$store.state.currentPracticeId },
                })
                .then((response) => {
                  var blob = base64.toBlob(response.data, 'application/pdf');
                  pdfWindow.location = URL.createObjectURL(blob);
                })
                .catch((error) => {
                  pdfWindow.close();
                  console.error('Something went wrong fetching the price list', error);
                  alert('There was an error downloading the price list please try again later');
                });
            },
            fetchPracticePrefs: function () {
              api
              .get('/api/v1/practices/' + this.$store.state.currentPracticeId + '/preferences', {
              })
              .then((response) => {
                  this.preferences = {
                      showReturnLabels: response.data.data.is_allowed_return_labels
                  };
              })
              .catch((reason) => {
                  console.log('Catch practice preferences error');
                  console.log(reason);
              });
          },
        },
        computed: {
            canSeePriceList() {
                if (this.$store.state.currentPractice === null) {
                    return false;
                }
                return this.$store.state.currentPractice.limited_to_company;
            },
        },
        mounted() {
            this.fetchPracticePrefs();
        },
    }

</script>

<style scoped lang="scss">
.action
{
  padding-bottom: 20px;

  .action-link
  {
    display: flex;
    align-items: center;
  }

  .action-icon
  {
    aspect-ratio: 1/1;
    line-height: 0;
    font-size: 6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    width: 70px;
  }
}

.quick-link
{
  text-decoration: none;
  display: flex;
  cursor:pointer;

  .icon-column
  {
    display: flex;
    flex-direction: column;
    margin-right: $spacer;
  }

  .icon
  {
    background: $swift-lighter-grey;
    border-radius: 10px;
    aspect-ratio: 1/1;
    font-size: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 70px;
  }

  .text
  {
    flex-grow: 1;
    margin-right: $spacer;
  }

  .text-description
  {
    line-height: 1.3em;
  }

  .arrow
  {
    img
    {
      width: 30px;
      margin-top: 10px;
    }
  }

  &:hover
  {
    .icon
    {
      background: $swift-light-grey;
      transition: 0.5s;
    }
  }
}
</style>